export default __webpack_public_path__ + "static/seo-presserom-b0e0f7b0b37b0b14c9813225a378f810.png";